module.exports = __webpack_public_path__ + "static/media/undraw_gift1_sgf8.d642a768.svg";